import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import SurrenderDocumentsDrawer from "./SurrenderDocumentsDrawer";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  allImprestSurrender,
  imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
  AllImprestSurrenderColumns,
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import ImprestSurrenderForm from "./form";

const base_url = HRService.uri;

function ImprestSurrenderTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
  isSubRight: true,
  entity: "Imprest Surrender",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

  ViewSurrenderLineByApplication: {
    key: "surenderLine",
    button_name: "View Surrender Line",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

  // ---------- APPROVE ----------
  APPROVEIMPRESTSURRENDER: {
    key: "APPROVEIMPRESTSURRENDER",
    button_name: "Approve",
    Show_Button: (row) => row.statusId === 1, // only when pending
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

    REJECTIMPRESTSURRENDER: {
      key: "REJECTIMPRESTSURRENDER",
      button_name: "Reject",
      Show_Button: (row) => row.statusId === 1, // only when pending
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },

  showStatus: true,
};

  return (
    <Box m="2px">
      <DynamicTable
        title="Imprest Surrender"
        subtitle="View all imprest Surrenders, create or Edit"
        columns={AllImprestSurrenderColumns}
        FormComponent={ImprestSurrenderForm}
        query={allImprestSurrender}
        actions={actions}
        base_url={base_url}
      />
      <SurrenderDocumentsDrawer
        open={docsDrawerOpen}
        onClose={() => {
          setDocsDrawerOpen(false);
          setSelectedRecordForDocs(null);
        }}
        surrenderId={selectedRecordForDocs?.id}
      />
    </Box>
  );
}

export default ImprestSurrenderTable;
